var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"pb-4 body-1"},[_c('router-link',{attrs:{"to":`/paymentMethods/?linkcode=${_vm.$route.query.linkcode}`}},[_vm._v("\n    "+_vm._s(_vm.text.change)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }